import { useAuth } from "@clerk/clerk-react";
import PopUp from "Components/PopUp/PopUp";
import RadioButtonGroup from "Components/RadioButtonGroup/RadioButtonGroup";
import TextInput from "Components/TextInput/TextInput";
import { Button } from "Components/ui/button";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLiveChallenges, submitTransaction } from "../../../../../../Redux/Profile/ProfileActions";
import WarningDiv from "../WarningDiv/WarningDiv";
import { set } from "date-fns";

function DepositPopup({ open, setOpen }) {

  const dispatch = useDispatch();
  const {getToken} = useAuth();
  const { liveChallenges,submitTransactionLoading , submitTransactionSuccess} = useSelector((state) => state.ProfileReducer);

  const [selected, setSelected] = useState();

  const [value, setValue] = useState();

  const [selectedItem, setSelectedItem] = useState({});


  const handleSubmit = () => {
    dispatch(submitTransaction(
      {
        accountId: selectedItem?.ChallengeStage?.[0]?.accountId,
        challengeId: selectedItem?.id,
        amount: parseFloat(value),
      },
      getToken
    ))
  }

  useEffect(()=>
  {
if(submitTransactionSuccess)
  {
    setOpen(false)
  }
  },[submitTransactionSuccess])
  

  useEffect(()=>
  {
if(!open)
{
  setValue("")
  setSelected("")
  setSelectedItem({})
}
  },[open])
  return (
    <PopUp title={"Transfer"} open={open} setOpen={setOpen}>
      <div className="flex flex-col gap-4 w-full">
        <div className="mb-4">
          <div className="text-lg font-N_Roman mb-2">Your Challenges</div>
          {liveChallenges?.length === 0 ? (
            <div className="text-grey font-g_bold">No Live Challenges!</div>
          ) : (
            <RadioButtonGroup
              grid={2}
              uniqueName={"Challenges"}
              data={liveChallenges?.map((challenge) => ({
                label: (
                  <div className="w-full">
                    <div>
                      <div className="text-primary text-xs font-N_Roman">
                        Stage {challenge?.ChallengeStage?.sequence}
                      </div>
                      <div className="font-[15px] font-g_regular ">
                        {challenge?.Balance?.amount?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}{" "}
                        Challenge{" "}
                        <span className="text-[10px] font-N_Roman opacity-[0.4]">
                          #{challenge?.ChallengeStage?.[0]?.Account?.login}
                        </span>
                      </div>
                    </div>
                    <hr className="my-2 opacity-[0.07] w-full" />
                    <div>
                      <div className="text-[11px] font-N_Roman opacity-[0.29]">
                        Available Funds
                      </div>
                      <div className="text-lg text-green font-N_Medium -mt-1">
                        {challenge?.profit?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                      </div>
                    </div>
                  </div>
                ),
                value: challenge?.id,
                challenge: challenge,
              }))}
              checked={selected}
              setChecked={(selected) => {
                setSelected(selected);
              }}
              setSelectedItem={setSelectedItem}
            />
          )}
        </div>
        <div>
          <TextInput
            label="Amount to Deposit"
            required={true}
            placeholder="500"
            type="number"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className={"border-border-radio"}
            labelClassName={"text-lg font-N_Roman"}
          />
        </div>

        {selectedItem && selectedItem?.ChallengeStage?.[0]?.profitShare && (
          <>
            <WarningDiv>
              Your transfer will follow an{" "}
              {selectedItem?.ChallengeStage?.[0]?.profitShare}/
              {100 - selectedItem?.ChallengeStage?.[0]?.profitShare} profit
              split, with {selectedItem?.ChallengeStage?.[0]?.profitShare}%
              allocated to you.
            </WarningDiv>
          </>
        )}
        <WarningDiv>
          The first payout becomes available 30 days after your first trade.
          Subsequent payouts will follow a 14-day cycle.
        </WarningDiv>

        <Button className="mt-4" disabled={!selected || !value || submitTransactionLoading}
        onClick={handleSubmit}
        >
          {submitTransactionLoading ? "Processing..."  :"Submit"}
        </Button>
      </div>
    </PopUp>
  );
}

export default DepositPopup;
